import { cn } from '@/lib/utils'

/**
 * A text block's text (z8nrz7djyy), drawn the same way on the builder canvas and
 * on the filled form so the author edits exactly what the filler will read.
 *
 * Plain text: `whitespace-pre-line` keeps the author's line breaks and blank
 * lines between paragraphs, and React escapes the content, so there is nothing
 * to sanitize. No label, no asterisk — it spans the field's width.
 */
export function TextBlock({ text, className }: { text: string; className?: string }) {
  return (
    <p
      data-testid='text-block'
      className={cn('whitespace-pre-line break-words text-sm leading-relaxed text-foreground', className)}
    >
      {text}
    </p>
  )
}
